import svgPaths from '../../imports/svg-ffwqtalyat';
import type { FlashIconProps } from './types';

export function FlashIcon({ isOn, onClick, ariaLabelOn, ariaLabelOff }: FlashIconProps) {
  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center space-y-2 p-4 hover:bg-muted rounded-xl transition-all duration-200 active:scale-95 cursor-pointer"
      aria-label={isOn ? ariaLabelOff : ariaLabelOn}
    >
      <div className={`w-12 h-12 relative ${isOn ? 'text-primary' : 'text-foreground'}`}>
        <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 60 60">
          <path
            d={svgPaths.p15148100}
            fill="currentColor"
            className="transition-colors duration-200"
          />
        </svg>
        {isOn && (
          <div className="absolute inset-0 rounded-full bg-primary/20 animate-pulse"></div>
        )}
      </div>
    </button>
  );
}
